module.exports = __webpack_public_path__ + "static/media/pic-large.78c03cc5.jpg";